import { format, parseISO } from 'date-fns';

/**
 * Format a cycleId (YYYY-MM-DD) to MM/DD/YYYY for display
 */
export const formatCycleDate = (cycleId) => {
  try {
    return format(parseISO(cycleId), 'MM/dd/yyyy');
  } catch {
    return cycleId;
  }
};

/**
 * Normalize cycle input formats into YYYY-MM-DD.
 * Accepts:
 *  - YYYY-MM-DD
 *  - MM/DD/YYYY
 *  - MM-DD-YYYY
 *  - MMDDYYYY
 */
export const normalizeCycleId = (cycleInput) => {
  if (!cycleInput || typeof cycleInput !== 'string') return null;

  const raw = cycleInput.trim();

  // yyyy-mm-dd (canonical)
  const isoMatch = /^\d{4}-\d{2}-\d{2}$/;
  if (isoMatch.test(raw)) {
    const parsed = parseISO(raw);
    if (!Number.isNaN(parsed.getTime())) return raw;
    return null;
  }

  // mm/dd/yyyy or mm-dd-yyyy
  const slashDashMatch = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/;
  const slashDash = raw.match(slashDashMatch);
  if (slashDash) {
    let [, mm, dd, yyyy] = slashDash;
    mm = mm.padStart(2, '0');
    dd = dd.padStart(2, '0');
    const candidate = `${yyyy}-${mm}-${dd}`;
    const parsed = parseISO(candidate);
    if (!Number.isNaN(parsed.getTime())) return candidate;
    return null;
  }

  // mmddyyyy
  const compactMatch = /^(\d{8})$/;
  if (compactMatch.test(raw)) {
    const mm = raw.slice(0, 2);
    const dd = raw.slice(2, 4);
    const yyyy = raw.slice(4, 8);
    const candidate = `${yyyy}-${mm}-${dd}`;
    const parsed = parseISO(candidate);
    if (!Number.isNaN(parsed.getTime())) return candidate;
    return null;
  }

  // Last-ditch try with Date.parse for 4-digit year positions
  const parsedDate = new Date(raw);
  if (!Number.isNaN(parsedDate.getTime())) {
    const y = parsedDate.getFullYear();
    const m = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const d = String(parsedDate.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  return null;
};
